import RouteComponent from "./Components/RouteComponent";
import "./App.css";


function App() {
  return (
    <div className="App">
      <RouteComponent />
    </div>
  );
}

export default App;

